import styled from "styled-components";
import * as React from "react";

const StyledLink = styled.a`
  text-decoration: none;
  transition: all 100ms;
  color: var(--main-logo);
  white-space: nowrap;

  &:hover {
    filter: brightness(1.1);
  }
`


export default StyledLink